/**
 *
 * ComparativeAnalysis
 *
 */

import "./index.less"

import { Button, Checkbox, Popover, Select, Spin } from "antd"
import { Icon } from "@ant-design/compatible"
import {
  ACTION_PLANS,
  COMPARATIVE_ANALYSIS,
  COMPARATIVE_ANALYSIS_TEAM,
  DISABLE,
  PROMO,
  ROLE_LEADER,
  TYPE_SURVEY,
  WORKING_ENVIRONMENT_LABEL,
  ROLE_AMBASSADOR
} from "../../../utils/constants"
import {
  LOCAL_ACTIVE_ROL,
  LOCAL_ANONYMITY,
  LOCAL_ANONYMITY_LEADERS,
  isModeInModuleBySlug,
  isModuleBySlug,
  isLeader,
  isAdmin,
  isAmbassador,
} from "../../../utils/storage"
import { LeftOutlined, QuestionCircleFilled } from "@ant-design/icons"
import { get, isEmpty, isEqual } from "lodash"
import {
  getDivisionsChildsWatcher,
  getDivisionsRowsWatcher,
  getDivisionsWatcher,
  getFiltersWatcher,
  getIndicatorWatcher,
  getMeasureColorRangeWatcher,
  getMeasureInfoSegmentWatcher,
  getMeasureWatcher,
} from "./actions"
import {
  makeSelectCountEmployees,
  makeSelectDivisionTotal,
  makeSelectDivisions,
  makeSelectFiltersDivisions,
  makeSelectHeaders,
  makeSelectIndicator,
  makeSelectIndicatorLoading,
  makeSelectIsLoading,
  makeSelectIsLoadingHeaders,
  makeSelectMeasureGeneral,
  makeSelectMeasureRangeColor,
  makeSelectFiltersSegments,
  makeSelectMeasureInfo,
  makeSelectLastPage,
} from "./selectors"
import {
  makeSelectCurrentMedition,
  makeSelectLoadingMeditions,
  makeSelectMeditions,
} from "containers/Report/Header/selectors"

import ComparativeAnalysisTable from "components/ComparativeAnalysisTable"
import EmptyStateAnonymity from "components/EmptyStateAnonymity"
import { Helmet } from "react-helmet"
import Layout from "components/Layout"
import { Link } from "react-router-dom"
import MeasurementColorRange from "../../../components/MeasurementColorRange"
import ModalActionPlanCreate from "components/ModalActionPlanCreate"
import React from "react"
import ReportHeader from "containers/Report/Header"
import SelectHR from "components/Select"
import { compose } from "redux"
// import PropTypes from 'prop-types';
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import injectReducer from "utils/injectReducer"
import injectSaga from "utils/injectSaga"
import reducer from "./reducer"
import saga from "./saga"
import { woopraTrack } from "../../../utils/woopra/woopraTracker"
import ComparativeAnalysisLeadershipTable from "../../../components/ComparativeAnalysisTable/leader"
import { validate } from "../../../utils/functions"
import { loadTexts } from "../../../utils/i18n"

const { Option } = Select

const recursiveFindChildsId = (array = [], data) => {
  array.push(data.id)
  if (data.childs && data.childs.length > 0) {
    data.childs.map((e) => recursiveFindChildsId(array, e))
  }
  return array
}
/* eslint-disable react/prefer-stateless-function */
export class ComparativeAnalysis extends React.Component {
  intlComparativeAnalysis = loadTexts("reports_comparative_view")
  intlComparativeAnalysisFilters = this.intlComparativeAnalysis.filters
  leader = false
  state = {
    measure_id: this.props.match.params.id,
    openDimensions: [],
    openDivisions: [],
    filters: [
      {
        id: "all",
        name: this.intlComparativeAnalysisFilters.divisions,
      },
      {
        id: "age",
        name: this.intlComparativeAnalysisFilters.age,
      },
      {
        id: "gender",
        name: this.intlComparativeAnalysisFilters.gender,
      },
      {
        id: "antiquity",
        name: this.intlComparativeAnalysisFilters.timeCompany,
      },
      {
        id: "position_level",
        name: this.intlComparativeAnalysisFilters.hierarchCategory,
      },
      {
        id: "location",
        name: this.intlComparativeAnalysisFilters.geographLocation,
      },
    ],
    selectedFilter: "all",
    modalBox: false,
    indicatorLoading: false,
    isEngagement: false,
    indicatorSelected: {
      name: "Integridad",
      color: "#cbcbcb",
      value: "85%",
      questions: [
        {
          id: 1,
          question: "Me siento orgulloso de trabajar en esta organización",
          color: "#55C8AE",
          value: "75%",
        },
        {
          id: 1,
          question: "Me siento orgulloso",
          color: "#F6B673",
          value: "75%",
        },
        {
          id: 1,
          question:
            "Me siento orgulloso siento siento siento siento siento siento siento siento",
          color: "#f0f0f0",
          value: "75%",
        },
      ],
    },
    checkboxEngagement: false,
    filterDivision: null,
    filterSegment: null,
    modalActionPlanCreate: false,
    cantCreatePDA: false,
    divisionSegment:false,
    tabGeneral:true
  }

  page = 1

  componentDidMount() {
    this.leader = this.props.location.pathname.indexOf("teams") !== -1
    if (this.leader) {
      let filters = this.state.filters
      filters[0].name = "Equipos"
      this.setState({
        filters,
      })
    }
    const searchLocation = getUrlParams(location.search)
    const validSegment=searchLocation ? isNaN(searchLocation.id_segment)? false:true : false


    const select_segment=isNaN(this.state.filterSegment)?null :this.state.filterSegment
    const id_segment = searchLocation ? isNaN(searchLocation.id_segment)? select_segment:searchLocation.id_segment : null
    this.props.getFilters({ measure: this.state.measure_id, id_segment })
    this.props.getMeasure({ measure: this.state.measure_id, id_segment })
    this.setState({
      filterDivision: searchLocation
        ? parseInt(searchLocation.id_division)
        : null,
    })
    this.setState({
      filterSegment: searchLocation
        ? parseInt(searchLocation.id_segment)
        : null,
    })
    this.props.getMeasureColorRange({
      measure: this.state.measure_id,
      id_segment,
    })
    this.props.getMeasureInfo({
      id_measure: this.state.measure_id,
      id_segment,
    })
   /*
    this.props.getDivisions({
      leader: this.leader,
      measure: this.state.measure_id,
      filter: this.state.selectedFilter,
      isEngagement: this.state.isEngagement,
      params: searchLocation,
      id_segment,
      page: this.page
    }) */
  }

  getDivisionScroller = (page) => {
    const searchLocation = getUrlParams(location.search)
    const select_segment=isNaN(this.state.filterSegment)?undefined :this.state.filterSegment
    const id_segment = searchLocation ? isNaN(searchLocation.id_segment)? select_segment:searchLocation.id_segment : null

      this.props.getDivisionsRows({
        leader: this.leader,
        measure: this.state.measure_id,
        filter: this.state.selectedFilter,
        isEngagement: this.state.isEngagement,
        params: searchLocation,
        id_segment,
        page
      })

    this.page = page

  }

  componentDidUpdate(nextProps) {
    const searchLocation = getUrlParams(location.search)
    const select_segment=isNaN(this.state.filterSegment)?undefined :this.state.filterSegment
    const id_segment = searchLocation ? isNaN(searchLocation.id_segment)? select_segment:searchLocation.id_segment : undefined

    // if(this.props.isLoading && this.isLoadingExtraRows){
    //   this.isLoadingExtraRows = false
    // }
    // if(this.state.isLoadingExtraRows){
    //   this.setState({isLoadingExtraRows: false})
    // }
    if (!isEqual(this.props.measureInfo, nextProps.measureInfo)) {
      this.setState(
        {
          isEngagement: this.props.measureInfo.is_engagement,
          checkboxEngagement: this.props.measureInfo.is_engagement,
        },
        () => {
          this.props.getDivisions({
            first: true,
            leader: this.leader,
            measure: this.state.measure_id,
            isEngagement: this.state.isEngagement,
            params: searchLocation,
            idDivisionParent: searchLocation
              ? searchLocation.id_divisionParent
              : null,
            id_segment,
            page: this.page
          })
        }
      )
    }
    if (
      Array.isArray(this.props.meditions) &&
      !isEqual(this.props.meditions, nextProps.meditions)
    ) {
      let current = this.props.meditions.find(
        (e) => e.id_measure == this.props.match.params.id
      )

      if (current) {
        this.setState(
          {
            isEngagement: current.engagement,
            checkboxEngagement: current.engagement,
          },
          () => {
            this.props.getDivisions({
              first: true,
              leader: this.leader,
              measure: this.state.measure_id,
              isEngagement: this.state.isEngagement,
              params: searchLocation,
              idDivisionParent: searchLocation
                ? searchLocation.id_divisionParent
                : null,
              id_segment,
              page: this.page
            })
          }
        )
      }
    }
  }

  clickFilter = () => {
    const searchLocation = getUrlParams(location.search) || {}
    const select_segment=isNaN(this.state.filterSegment)?undefined :this.state.filterSegment
    const id_segment = searchLocation ? isNaN(searchLocation.id_segment)? select_segment:searchLocation.id_segment : undefined
    this.page = 1 // restart page index
    this.props.getDivisions({
      leader: this.leader,
      measure: this.state.measure_id,
      filter: this.state.selectedFilter,
      isEngagement: this.state.isEngagement,
      params: searchLocation,
      id_segment,
      page: this.page
    })

    const divisionDefault = this.props.divisionsTotal?.id_division || undefined
    if (
      !this.emptyValues(divisionDefault) &&
      this.emptyValues(searchLocation.id_division)
    ) {
      this.setState({
        filterDivision: parseInt(divisionDefault),
      })
    }
    if(id_segment){
      const segmentDivisions = this.props.filtersSegments.find(item => item.id_segment === parseInt(id_segment));
      this.state.divisionSegment=segmentDivisions.divisions;
    } else{
      this.state.divisionSegment=false}
  }
  valuesDivisions=()=>{
    const values =this.state.divisionSegment==false? this.props.filtersDivisions:
    this.props.filtersDivisions.filter( (d) => this.state.divisionSegment.includes(d.id_division))
    return values;
  }
  valuesSegments=()=>{
    const values =this.state.filterDivision ? this.props.filtersSegments.filter( (s) => s.divisions.includes(this.state.filterDivision)) :
    this.props.filtersSegments
    return values;
  }
  emptyValues = (text) => {
    return [0, null, undefined, "", []].includes(text)
  }

  clickDimension = (id) => {
    const { openDimensions } = this.state
    const index = openDimensions.findIndex((e) => e === id)
    if (index > -1) {
      openDimensions.splice(index, 1)
    } else {
      openDimensions.push(id)
    }
    this.setState({
      openDimensions,
    })
  }

  clickDivision = (item) => {
    const { openDivisions, measure_id, isEngagement } = this.state
    const searchLocation = getUrlParams(location.search) || {}
    const select_segment=isNaN(this.state.filterSegment)?undefined :this.state.filterSegment
    const id_segment = searchLocation ? isNaN(searchLocation.id_segment)? select_segment:searchLocation.id_segment : undefined
    const that = this
    let idToUse = item.id_position ? item.id_position : item.id_division
    const index = openDivisions.findIndex((e) => e === idToUse)
    if (index > -1) {
      openDivisions.splice(index, 1)
      const indexChilds = recursiveFindChildsId([], item)
      indexChilds.map((iC) => {
        const indexChild = openDivisions.findIndex((e) => e === iC)
        if (indexChild > -1) {
          openDivisions.splice(indexChild, 1)
        }
      })
      this.props.getDivisionsChilds({
        leader: this.leader,
        measure: measure_id,
        id_division: idToUse,
        props: this.props.divisions,
        item,
        type: 2,
        isEngagement,
        params: { id_segment },
      })
    } else {
      openDivisions.push(idToUse)
      this.props.getDivisionsChilds({
        leader: this.leader,
        measure: measure_id,
        id_division: idToUse,
        props: this.props.divisions,
        item,
        type: 1,
        isEngagement,
        params: { id_segment },
      })
    }

    that.setState({
      openDivisions,
    })
  }

  clickIndicator = (item) => {
    const searchLocation = getUrlParams(location.search) || {}

    this.props.getIndicator({
      measure: this.state.measure_id,
      id: item.id_measure_metric,
      params: searchLocation,
    })
    this.setState(
      {
        indicatorLoading: true,
        modalBox: true,
      },
      () => {
        setTimeout(() => {
          this.setState({
            indicatorLoading: false,
          })
        }, 2000)
      }
    )
  }

  setNameMetricsTotalLabel = () => {
    const { measure_general, measureInfo } = this.props
    let surveyType = get(measure_general, "id_survey_type", null)
    let hasLabel = get(measure_general, "metric_total_label", null)
    let response = get(measure_general, "metric_total_label", null)

    return response.toUpperCase()
  }

  render() {
    if (this.leader) {
      const isComparativeAnalysisTeam = isModeInModuleBySlug(
        COMPARATIVE_ANALYSIS_TEAM
      )
      if (isComparativeAnalysisTeam === DISABLE) {
        return <div />
      }
    } else {
      const isComparativeAnalysis = isModeInModuleBySlug(COMPARATIVE_ANALYSIS)
      if (isComparativeAnalysis === DISABLE) {
        return <div />
      }
    }
    const {
      selectedFilter,
      filters,
      openDimensions,
      openDivisions,
      measure_id,
      isEngagement,
      checkboxEngagement,
      filterDivision,
      filterSegment,
      modalActionPlanCreate,
      cantCreatePDA,
      tabGeneral,
    } = this.state
    const {
      headers,
      divisions,
      isLoading,
      indicatorLoading,
      indicatorSelected,
      history,
      match,
      isLoadingMeditions,
      isLoadingHeaders,
      filtersDivisions,
      filtersSegments,
      countEmployees,
      currentMedition,
      measureColorRange,
      measureInfo,
      lastPage
    } = this.props
    let isFreemium = false
    if (this.leader) {
      isFreemium = isModeInModuleBySlug(COMPARATIVE_ANALYSIS_TEAM) === PROMO
    } else {
      isFreemium = isModeInModuleBySlug(COMPARATIVE_ANALYSIS) === PROMO
    }
    const currentFilterName = filters.find((f) => selectedFilter === f.id)
    const divisionSelectedInfo = divisions.find(
      (d) => d.id_division === filterDivision
    )
    const divisionFilterSelectedInfo = filtersDivisions.find(
      (d) => d.id_division === filterDivision
    )
    const anonymityCount = !validRole({ role: [5, 6] })
      ? LOCAL_ANONYMITY()
      : LOCAL_ANONYMITY_LEADERS()

    const anonymityValidate = LOCAL_ACTIVE_ROL() == ROLE_AMBASSADOR ?(countEmployees < parseInt(measureInfo.countAnonymity)|| countEmployees === 0):
      countEmployees < parseInt(anonymityCount?anonymityCount:measureInfo.countAnonymity) || countEmployees === 0
    const isUserLeader = LOCAL_ACTIVE_ROL() === ROLE_LEADER.toString()
    const searchLocation = getUrlParams(location.search)
    const validSegment=searchLocation ? isNaN(searchLocation.id_segment)? false:true : false
    this.state.tabGeneral=LOCAL_ACTIVE_ROL() == ROLE_AMBASSADOR ? (validSegment ? (this.valuesSegments().length==1?true:false):true):(searchLocation ? isNaN(searchLocation.id_segment)? true:false : true)

    let paramsPath = { ...searchLocation }
    const id_divisionParent =
      isEmpty(paramsPath.id_divisionParent) ||
      paramsPath.id_divisionParent === undefined
        ? ""
        : `&id_divisionParent=${paramsPath.id_divisionParent}`
    const id_division =
      isEmpty(paramsPath.id_divisionParent) ||
      paramsPath.id_divisionParent === undefined
        ? ""
        : `?id_division=${paramsPath.id_divisionParent}`

    let idSegment = validate.empty(paramsPath.id_segment)
      ? ""
      : `&id_segment=${paramsPath.id_segment}`

    const isActionPlans = isModuleBySlug(ACTION_PLANS)
    const isLeaderShip =
      measureInfo.id_survey_type === TYPE_SURVEY.leadership.idSurveyType
    const hashRolLeader = isLeader()
    const isRolAdmin = isAdmin()
    const filterSegments = { id: "segments", name: "Segmentos" }
    measureInfo.segments === undefined ? '' : ((measureInfo.segments.length >0  && this.state.tabGeneral) ? filters.some(e => e.id === 'segments') ? "" : filters.splice(1,0,filterSegments) : "")
    if (isEmpty(id_divisionParent)) {
      idSegment = validate.empty(paramsPath.id_segment)
        ? ""
        : `&id_segment=${paramsPath.id_segment}`
    } else if (isEmpty(id_division)) {
      idSegment = validate.empty(paramsPath.id_segment)
        ? ""
        : `&id_segment=${paramsPath.id_segment}`
    } else if (isEmpty(id_divisionParent) && isEmpty(id_division))
      idSegment = validate.empty(paramsPath.id_segment)
        ? ""
        : `?id_segment=${paramsPath.id_segment}`
    else {
      idSegment = validate.empty(paramsPath.id_segment)
        ? ""
        : `&id_segment=${paramsPath.id_segment}`
    }
    const hideFilter = isLeaderShip && hashRolLeader && !isRolAdmin
    const isSegment= measureInfo.segments === undefined ? false : ((measureInfo.segments.length >0) ? true : false)
    const renderReturn = () => {
      const paramDivision = id_division === "" ? "" : `?id_division=${paramsPath.id_division}`
      
      let baseUrl = "/reports/measure/"

      let link = `${baseUrl}${this.props.measureInfo.id_survey_type}/${this.props.match.params.id}`

      if (!isLeader()) {
        link = `${baseUrl}${this.props.measureInfo.id_survey_type}/${this.props.match.params.id}${paramDivision}`
      }
      if(isAmbassador()){
        link = `${baseUrl}${this.props.measureInfo.id_survey_type}/${this.props.match.params.id}${paramDivision}`
      }

      
      return link

    }
    const actionPlansComponent = () => {
      if (isLoadingHeaders) {
        return null
      }

      if (measureInfo && get(measureInfo, "id_survey_type") !== 1) {
        return null
      }

      if (!cantCreatePDA || !isActionPlans) {
        return null
      }
      const isEmbedded = window.top !== window.self;
      return (
        <div
          style={{
            position: "absolute",
            top: 76,
            right: 80,
          }}>
          <Button
            type="primary"
            style={{
              ...(isEmbedded && {
                position: 'relative',
                bottom: 55,
                left: 5,
              })
            }}
            onClick={() => {
              woopraTrack("Crear plan de acción")
              this.setState({ modalActionPlanCreate: true })
            }}>
            {this.intlComparativeAnalysis.buttonActionPlan}
          </Button>
        </div>
      )
    }

    return (
      <Layout>
        <Helmet>
          <title>{this.intlComparativeAnalysis.titlePage}</title>
          <meta
            name="description"
            content="Description of DimensionByDivision"
          />
        </Helmet>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginBottom: 60,
          }}>
          {actionPlansComponent()}
          {!isLoadingHeaders ? (
            <div className="comparativeAnalysis" style={{ ...(typeof window.Intercom !== "undefined" &&
              window.self === window.top && {
              marginBottom: "100px"}) }}>
              <div className="comparativeAnalysis-header">
                <div className="comparativeAnalysis-header-btn-back">
                  <span>
                    <Link to={renderReturn()}>
                      <LeftOutlined />
                      {` ${this.intlComparativeAnalysis.link}`}
                    </Link>
                  </span>
                </div>
              </div>
              <div className="comparativeAnalysis-header-filters">
                <div>
                  <b>{this.intlComparativeAnalysis.title}</b>
                    {isUserLeader
                      ? ""
                      : this.leader
                      ? (
                        <>
                        <b>: {selectedFilter=='all'? 'Líderes':currentFilterName.name}</b>
                          {
                            `${
                            measureInfo &&
                            measureInfo.segment_name &&
                            measureInfo.segment_name.length !== 0
                              ? `- ${measureInfo.segment_name}`
                              : ""
                            }`
                          }
                        </>
                        )
                      : `: ${currentFilterName.name} ${
                          measureInfo &&
                          measureInfo.segment_name &&
                          measureInfo.segment_name.length !== 0
                            ? `- ${measureInfo.segment_name}`
                            : ""
                        }`}
                </div>
                {!this.leader && !isLoading && (
                  <div className="comparativeAnalysis-header-filters-column color-gray-low">
                    {`${this.intlComparativeAnalysis.total} ${countEmployees ||
                      0} ${this.intlComparativeAnalysis.collaborators}`}
                  </div>
                )}
              </div>
              <div
                className="comparativeAnalysis-header-filters"
                style={{ marginTop: 15 }}>
                {!hideFilter && (
                  <div>
                    <span style={{ fontWeight: 600, fontSize: 13 }}>
                      {this.intlComparativeAnalysis.visualizeBy}
                    </span>
                    <Select
                      defaultValue={selectedFilter}
                      onChange={(s) => {
                        this.setState({ selectedFilter: s }, () =>
                          this.clickFilter()
                        )
                      }}
                      style={{ width: 200, marginLeft: 10 }}>
                      {filters.map((f, i) => (
                        <Option
                          disabled={isFreemium && f.id !== "all"}
                          className={
                            isFreemium &&
                            f.id !== "all" &&
                            "select-option-block"
                          }
                          key={i}
                          value={`${f.id}`}>
                          {`${f.name}`}
                        </Option>
                      ))}
                    </Select>
                    {isFreemium && (
                      <Popover
                        placement="top"
                        content={
                          <div style={{ maxWidth: 250 }}>
                            La <b>versión gratuita</b> únicamente permite
                            visualizar el análisis comparativo a nivel de
                            divisiones.
                          </div>
                        }>
                        <QuestionCircleFilled
                          style={{
                            color: "#D8D8D8",
                            verticalAlign: "baseline",
                            fontSize: "14px",
                            marginLeft: 8,
                          }}
                        />
                      </Popover>
                    )}

                    {isEngagement && (
                      <div
                        style={{
                          marginLeft: 10,
                          paddingLeft: 10,
                          height: 30,
                          paddingTop: 5,
                          display: "inline-block",
                        }}>
                        <Checkbox
                          checked={checkboxEngagement}
                          onChange={(e) =>
                            this.setState({
                              checkboxEngagement: e.target.checked,
                            })
                          }>
                          Engagement
                        </Checkbox>
                      </div>
                    )}
                  </div>
                )}
                <div className="comparativeAnalysis-header-filters-right">

                {tabGeneral && isSegment && !(LOCAL_ACTIVE_ROL() == ROLE_LEADER) && !(LOCAL_ACTIVE_ROL() == ROLE_AMBASSADOR && this.leader )&&(
                  <div className="comparativeAnalysis-header-filters-right-column">
                    <SelectHR
                      allowClear={LOCAL_ACTIVE_ROL() == ROLE_AMBASSADOR && this.valuesSegments().length==1 ? false:true}
                      value={filterSegment}
                      options={this.valuesSegments()}
                      placeholder={
                        this.intlComparativeAnalysis.placeholderSelectSegment
                      }
                      style={{ width: 300 }}
                      label="name"
                      labelKey="id_segment"
                     onChange={(selectedSegment) => {
                        selectedSegment = selectedSegment
                          ? selectedSegment.id_segment
                          : null
                          if(!selectedSegment){
                          }
                        this.setState(
                          { filterSegment: selectedSegment },
                          () => this.clickFilter()
                        )
                      }}
                    />
                  </div>
                )}
                {!this.leader && (
                  <div className="comparativeAnalysis-header-filters-right-column">
                    <SelectHR
                      allowClear={LOCAL_ACTIVE_ROL() != ROLE_AMBASSADOR}
                      value={filterDivision}
                      options={this.valuesDivisions()}
                      placeholder={
                        this.intlComparativeAnalysis.placeholderSelectDivision
                      }
                      style={{ width: 200 }}
                      label="name"
                      labelKey="id_division"
                      onChange={(selectedDivision) => {
                        selectedDivision = selectedDivision
                          ? selectedDivision.id_division
                          : null
                        if (selectedDivision) {
                          this.props.history.push(
                            `${this.props.history.location.pathname}?id_division=${selectedDivision}${id_divisionParent}${idSegment}`
                          )
                        } else {
                          this.props.history.push(
                            `${this.props.history.location.pathname}?${idSegment}`
                          )
                        }
                        this.setState(
                          { filterDivision: selectedDivision },
                          () => this.clickFilter()
                        )
                      }}
                    />
                  </div>
                )}
                </div>
              </div>

              <div style={{ marginTop: "10px", float: "right" }}>
                <div>
                  <MeasurementColorRange
                    measureColorRange={measureColorRange}
                  />
                </div>
              </div>

              {!isLoading && !this.leader && anonymityValidate ? (
                <EmptyStateAnonymity
                  count={countEmployees}
                />
              ) : (
                <div style={{ paddingTop: "20px" }}>
                  {this.leader && selectedFilter !== "all" ? (
                    <ComparativeAnalysisLeadershipTable
                      firstHeaderColumnText="LIDERAZGO"
                      isEngagement={checkboxEngagement}
                      openDimensions={openDimensions}
                      openDivisions={openDivisions}
                      clickDivision={(item) => this.clickDivision(item)}
                      clickDimension={(id) => this.clickDimension(id)}
                      clickIndicator={(item) => this.clickIndicator(item)}
                      headers={headers}
                      body={divisions}
                      loading={isLoading}
                      indicatorLoading={indicatorLoading}
                      indicatorSelected={indicatorSelected}
                      getDivisionsScroller={(page) => this.getDivisionScroller(page)}
                      lastPage={lastPage || 1}
                      currentPage={this.page || 1}
                    />
                  ) : (
                    <ComparativeAnalysisTable
                      firstHeaderColumnText={this.setNameMetricsTotalLabel()}
                      isEngagement={checkboxEngagement}
                      openDimensions={openDimensions}
                      openDivisions={openDivisions}
                      clickDivision={(item) => this.clickDivision(item)}
                      clickDimension={(id) => this.clickDimension(id)}
                      clickIndicator={(item) => this.clickIndicator(item)}
                      headers={headers}
                      body={divisions}
                      loading={isLoading}
                      indicatorLoading={indicatorLoading}
                      indicatorSelected={indicatorSelected}
                      getDivisionsScroller={(page) => this.getDivisionScroller(page)}
                      lastPage={lastPage || 1}
                      currentPage={this.page || 1}
                    />
                  )}
                </div>
              )}
            </div>
          ) : (
            <div className="ResultByDivisionComponent-table-body-loading">
              <Spin size="large" />
            </div>
          )}
        </div>
        <ModalActionPlanCreate
          visible={modalActionPlanCreate}
          onCancel={() => this.setState({ modalActionPlanCreate: false })}
          finish={() => {}}
          canCreate={(v) =>
            this.setState({ cantCreatePDA: v && !isUserLeader })
          }
          initialData={{
            measure: measureInfo && measureInfo.id_measure,
            division: divisionFilterSelectedInfo
              ? {
                  id_division: get(
                    divisionFilterSelectedInfo,
                    "id_division",
                    0
                  ),
                  division_name: get(divisionFilterSelectedInfo, "name", 0),
                }
              : null,
          }}
          fromAnalysis={true}
        />
      </Layout>
    )
  }
}

ComparativeAnalysis.propTypes = {
  // dispatch: PropTypes.func.isRequired,
}

const mapStateToProps = createStructuredSelector({
  isLoading: makeSelectIsLoading(),
  isLoadingHeaders: makeSelectIsLoadingHeaders(),
  headers: makeSelectHeaders(),
  divisions: makeSelectDivisions(),
  divisionsTotal: makeSelectDivisionTotal(),
  indicatorLoading: makeSelectIndicatorLoading(),
  indicatorSelected: makeSelectIndicator(),
  meditions: makeSelectMeditions(),
  isLoadingMeditions: makeSelectLoadingMeditions(),
  filtersDivisions: makeSelectFiltersDivisions(),
  filtersSegments: makeSelectFiltersSegments(),
  countEmployees: makeSelectCountEmployees(),
  currentMedition: makeSelectCurrentMedition(),
  measure_general: makeSelectMeasureGeneral(),
  measureColorRange: makeSelectMeasureRangeColor(),
  measureInfo: makeSelectMeasureInfo(),
  lastPage: makeSelectLastPage(),
})

function mapDispatchToProps(dispatch) {
  return {
    getDivisions: (params) => dispatch(getDivisionsWatcher(params)),
    getDivisionsRows: (params) => dispatch(getDivisionsRowsWatcher(params)),
    getDivisionsChilds: (params) => dispatch(getDivisionsChildsWatcher(params)),
    getIndicator: (params) => dispatch(getIndicatorWatcher(params)),
    getFilters: (params) => dispatch(getFiltersWatcher(params)),
    getMeasureColorRange: (params) =>
      dispatch(getMeasureColorRangeWatcher(params)),
    getMeasure: (params) => dispatch(getMeasureWatcher(params)),
    getMeasureInfo: (params) => dispatch(getMeasureInfoSegmentWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "comparativeAnalysis", reducer })
const withSaga = injectSaga({ key: "comparativeAnalysis", saga })

export default compose(withReducer, withSaga, withConnect)(ComparativeAnalysis)
